import { openNotification } from "../globals/Components/Notification/Notificaction";
import validateMessages from "../globals/Inputs/validateMessages";
import { MessageResponse } from "./system/types";

export const serverMessages = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    if (responseData.Error.status != 400) {       
        message = {
            code: responseData.Error.status,
            message: [validateMessages.serverError+":"+ responseData.Error.message]
        };
        openNotification("Error del sistema", validateMessages.serverError+":"+ responseData.Error.message)      
        
    }
    else {        
        const errorResponse = responseData.Error.message;        
        message = {
            code: responseData.Error.status,
            message: [errorResponse]
        };     
        openNotification("Advertencia", errorResponse)        
    }
    return message;  
};

export const serverMessagesLogin = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    debugger
    if (responseData.Error.status != 400) {       
        message = {
            code: responseData.Error.status,
            message: [validateMessages.serverError+":"+ responseData.Error.message]
        };   
        
       
    }
    else {        
        const errorResponse = responseData.Error.message;        
        message = {
            code: responseData.Error.status,
            message: [errorResponse]
        };   
         if(responseData.Error.message === "ERROR: Servidores no disponibles.")  {
            window.location.replace(process.env.REACT_APP_BASE_URL as string+"/error-server");
        }   
    }
    return message;  
};